export default "/images/fc7498256ff252e1d0e735f228c06483.avif";